import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { connect } from "react-redux";
import api from "APP_ROOT/api";
import { withSalesOrder } from "MODULES/SalesOrders/decorators";
import {
  ImprovedDropDown,
  ImprovedDropDownItem
} from "MODULES/shared/components/DropDown";
import ReverseCancellation from "./ReverseCancellation";
import RmaRequestModal from "./RmaRequest/RmaRequestModal";

function CancelledControls({ lineItem }) {
  return (
    <ImprovedDropDown menuClass="dropdown-menu-right large">
      <ImprovedDropDownItem
        id="reverse-cancellation"
        label="Reverse Cancellation"
        faIcon="undo"
        hideIf={
          _.get(lineItem, "inventory.status") !== "reserve_for_sale" ||
          _.get(lineItem, "inventory.consignment_type")
        }
        renderActive={<ReverseCancellation lineItem={lineItem} />}
      />
      <ImprovedDropDownItem
        label="Customer RMA Request"
        id="customer-rma-request"
        faIcon="cog"
        hideIf={_.get(lineItem, "inventory.status") !== "gone"}
        renderActive={<RmaRequestModal lineItem={lineItem} />}
      />
    </ImprovedDropDown>
  );
}

CancelledControls.propTypes = {
  lineItem: PropTypes.shape({
    id: PropTypes.number.isRequired,
    inventory: PropTypes.shape({
      status: PropTypes.string
    })
  })
};

export default connect(
  undefined,
  (dispatch, { lineItem, salesOrder, refresh, expireLineItems }) => ({
    reverseCancellation: () =>
      api.salesOrders.lineItems.cancellationReversal(lineItem.id).then(() =>
        refresh(salesOrder.get("id")).then(() => {
          expireLineItems();
          close();
        })
      )
  })
)(withSalesOrder(CancelledControls));



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/CancelledControls.jsx